import { Theme } from "@mui/material";

export const round = (value: number): number => {
  return Math.round(value * 1e5) / 1e5;
};

const BROWSER_DEFAULT_FONT_SIZE = 16;
export const rem = (px: number): string =>
  `${round(px / BROWSER_DEFAULT_FONT_SIZE)}rem`;

export const lightOrDark = (light: any, dark: any) => (theme: Theme) =>
  theme.palette.mode === "light" ? light : dark;
